<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>{{ admin ? 'Tanmenetek (összesítő)' : 'Tanmenetem' }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>{{ admin ? 'Tanmenetek' : 'Tanmenet feltöltése' }}</ion-card-title>
      <ion-card-subtitle *ngIf="!admin">
        Töltsd fel Excelből a tanmeneted. A napló ebből kínálja fel az óra témáját – a sorszám a
        tanév eleje óta megtartott órák sorszáma. Csak azokhoz az osztály–tantárgy párokhoz tölthetsz
        fel, amiket ebben a tanévben tanítasz.
      </ion-card-subtitle>
      <ion-card-subtitle *ngIf="admin">
        Az intézmény összes osztály–tantárgy párja és a hozzájuk feltöltött tanmenet állapota.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div class="tm-fejlec">
        <ion-select label="Tanév" label-placement="stacked" interface="popover" fill="outline"
                    [(ngModel)]="tanev" (ionChange)="betolt()">
          <ion-select-option *ngFor="let e of tanevek" [value]="e">{{ e }}/{{ e + 1 }}</ion-select-option>
        </ion-select>
        <ion-input label="Keresés" label-placement="stacked" fill="outline"
                   placeholder="osztály, tantárgy vagy tanár" [(ngModel)]="szuro"></ion-input>
      </div>

      <div class="tm-allapot" *ngIf="toltodik">
        <ion-spinner name="dots"></ion-spinner><span>Betöltés…</span>
      </div>
      <div class="tm-allapot hiba" *ngIf="!toltodik && hiba">
        <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
      </div>

      <ng-container *ngIf="!toltodik && !hiba">

        <!-- Összesítő: adminnál a hiány a lényeg, nem a meglévők száma. -->
        <div class="tm-osszegzes" *ngIf="osszesito">
          <div class="tm-kartya"><b>{{ osszesito.osszes_par }}</b><span>osztály–tantárgy pár</span></div>
          <div class="tm-kartya ok"><b>{{ osszesito.feltoltve }}</b><span>van tanmenet</span></div>
          <div class="tm-kartya baj"><b>{{ osszesito.hianyzik }}</b><span>hiányzik</span></div>
          <div class="tm-kartya figy" *ngIf="osszesito.arva">
            <b>{{ osszesito.arva }}</b><span>árva tanmenet</span>
          </div>
        </div>
        <ion-note color="medium" class="tm-sugo" *ngIf="osszesito?.arva">
          Az <b>árva</b> tanmenet olyan osztály–tantárgy párhoz tartozik, amit ebben a tanévben már
          senki nem tanít (megszűnt osztály vagy elment kolléga). Az adat megmarad, csak nincs kihez kötni.
        </ion-note>

        <div class="tm-ures" *ngIf="!szurtParok.length">
          <ng-container *ngIf="!admin">
            Ebben a tanévben nincs olyan osztály–tantárgy párod, amihez tanmenetet tölthetnél fel.
            Ha ez tévedés, a <b>tantárgyfelosztásban</b> vagy az órarendben hiányzik a besorolásod –
            szólj az iskolatitkárnak.
          </ng-container>
          <ng-container *ngIf="admin">Ebben a tanévben nincs osztály–tantárgy pár.</ng-container>
        </div>

        <div class="tm-tabla-burok" *ngIf="szurtParok.length">
          <table class="tm-tabla">
            <thead>
              <tr>
                <th>Osztály / csoport</th>
                <th>Tantárgy</th>
                <th *ngIf="admin">Tanár</th>
                <th class="szam">Órák</th>
                <th>Tanmenet</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of szurtParok" [class.kivalasztott]="kivalasztott === p">
                <!--  BONTOTT ÓRÁN A CSOPORT NEVE ÁLL ITT, AZ OSZTÁLYÉ NEM.
                      Egy csoport több osztályt is összefoghat, a pár `osztaly` mezője
                      viszont csak EGYET nevez meg közülük (a legkisebb azonosítójút) –
                      az a napló visszatalálásához kell, kiírva viszont félrevezet. Amit
                      a kolléga tanít, az a csoport; a kötött osztályok az alcímben. -->
                <td>
                  <ng-container *ngIf="!p.csoport_nev">{{ p.osztaly_nev }}</ng-container>
                  <ng-container *ngIf="p.csoport_nev">
                    {{ p.csoport_nev }}
                    <div class="tm-csoport" *ngIf="p.csoport_osztalyok?.length">
                      {{ p.csoport_osztalyok.join(', ') }}
                    </div>
                  </ng-container>
                </td>
                <td>{{ p.tantargy_nev }}</td>
                <td *ngIf="admin">{{ p.tanar_nev || '—' }}</td>
                <td class="szam">{{ p.orak || '—' }}</td>
                <td>
                  <span class="jel ok" *ngIf="p.sajat_tanmenet">{{ p.tanmenet_orak }} óra</span>
                  <!--  Öröklött: a csoportnak nincs saját tanmenete, de az osztályhoz van
                        (a csoport-oszlop előtti feltöltésekből). Meg kell különböztetni:
                        a kolléga különben azt hinné, hogy ő töltötte fel. -->
                  <span class="jel orokolt" *ngIf="p.orokolt_tanmenet"
                        title="Osztályszintű tanmenet – nem ehhez a csoporthoz készült">
                    {{ p.tanmenet_orak }} óra · osztályszintű
                  </span>
                  <span class="jel hiany" *ngIf="!p.feltoltve">nincs feltöltve</span>
                </td>
                <td class="muvelet">
                  <ion-button size="small" fill="clear" (click)="feltoltestKezd(p)">
                    {{ p.sajat_tanmenet ? 'Csere' : 'Feltöltés' }}
                  </ion-button>
                  <ion-button size="small" fill="clear" *ngIf="p.feltoltve" (click)="megnez(p)">Megnéz</ion-button>
                  <ion-button size="small" fill="clear" color="danger" *ngIf="p.sajat_tanmenet"
                              (click)="torol(p)">Törlés</ion-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </ng-container>
    </ion-card-content>
  </ion-card>
</ion-content>

<!-- ══════════════════════════════════════════════════════════════════════════
     FELTÖLTÉS – modálban.
     Korábban a lap ALJÁN nyílt ki egy panel: hosszú listánál a táblázat alatt
     nem is látszott, hogy egyáltalán megjelent valami, és a mentés gombig
     görgetni kellett. Modálban a feltöltés ott van, ahova a kattintás után néz
     az ember, a mentés pedig rögzített lábban ül – nem tűnik el a hosszú
     előnézet alatt.
     ══════════════════════════════════════════════════════════════════════════ -->
<ion-modal [isOpen]="!!kivalasztott" (didDismiss)="megsem()">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>{{ parNev(kivalasztott) }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="megsem()"><ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div class="tm-feltolto">
        <div class="tm-sugo">
          Excel (.xlsx/.xls) vagy CSV. Kell egy <b>Téma</b> (vagy Tananyag, Témakör) fejlécű oszlop;
          ha van <b>Óraszám</b> (vagy Sorszám) oszlop is, azt használjuk sorszámnak, különben a
          sorok sorrendje adja. Az üres sorokat kihagyjuk.
        </div>

        <!--  HATÓKÖR. Van tantárgy, ahol az évfolyam együtt halad (matematika), és van,
              ahol csoportonként más az ütem (nyelvek). A feltöltő tudja, melyik – ezért
              ő állítja be, nem a rendszer találgat. -->
        <ion-item lines="none" class="tm-hatokor" *ngIf="evfolyamKapcsolhato(kivalasztott)">
          <ion-toggle [(ngModel)]="egeszEvfolyam">Az egész évfolyamnak</ion-toggle>
        </ion-item>
        <!--  Osztály nélküli csoport (sportkör): nincs évfolyama, a tanmenet a csoporté. -->
        <ion-note color="medium" class="tm-csere" *ngIf="!evfolyamKapcsolhato(kivalasztott)">
          Ez a csoport nem egy osztályhoz tartozik (több osztály tanulói járnak ide), ezért a
          tanmenet <b>a csoporthoz</b> kerül fel.
        </ion-note>
        <ion-note color="medium" class="tm-csere" *ngIf="egeszEvfolyam && evfolyamKapcsolhato(kivalasztott)">
          A tanmenet az évfolyam <b>minden olyan osztályára</b> felkerül, ahol ezt a tantárgyat
          tanítják — <b>osztályszinten</b>. Amelyik csoportnak van saját tanmenete, azt nem
          írja felül: a csoport sajátja mindig erősebb.
        </ion-note>

        <!-- A cseréről ELŐRE szólunk, nem a mentés pillanatában: itt még van mit meggondolni. -->
        <ion-note color="danger" class="tm-csere" *ngIf="kivalasztott?.sajat_tanmenet">
          Ehhez a párhoz már van feltöltve {{ kivalasztott.tanmenet_orak }} óra – a mentés
          <b>lecseréli</b> a teljes tanmenetet.
        </ion-note>
        <ion-note color="medium" class="tm-csere" *ngIf="kivalasztott?.orokolt_tanmenet">
          Ehhez a csoporthoz még nincs saját tanmenet: most az <b>osztályszintű</b>
          ({{ kivalasztott.tanmenet_orak }} óra) érvényes rá. Amit feltöltesz, az <b>csak
          ehhez a csoporthoz</b> tartozik — a többi csoportét nem írja felül.
        </ion-note>

        <!-- A böngésző alap fájlmezője rejtve: gombként érthetőbb, és a kiválasztott
             fájl neve mellette olvasható marad. -->
        <input #fajlValaszto type="file" accept=".xlsx,.xls,.csv" hidden
               (change)="fajlValtozott($event)" />
        <div class="tm-fajlsor">
          <ion-button size="default" fill="outline" (click)="fajlValaszto.click()">
            <ion-icon slot="start" name="document-attach-outline"></ion-icon>
            {{ fajlNev ? 'Másik fájl' : 'Fájl kiválasztása' }}
          </ion-button>
          <span class="tm-fajl" *ngIf="fajlNev">{{ fajlNev }} — <b>{{ sorok.length }}</b> téma</span>
          <span class="tm-fajl halvany" *ngIf="!fajlNev">Excel (.xlsx/.xls) vagy CSV</span>
        </div>

        <div class="tm-elonezet" *ngIf="sorok.length">
          <table class="tm-tabla">
            <thead><tr><th class="szam">Óra</th><th>Téma</th></tr></thead>
            <tbody>
              <tr *ngFor="let s of sorok">
                <td class="szam">{{ s.oraszam }}</td>
                <td>{{ s.tema }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ion-content>

    <!-- A láb MINDIG látszik: enélkül úgy tűnt, nincs is mentés gomb, amíg a fájl
         be nem olvasódott. Így látszik a következő lépés, csak még nem aktív. -->
    <ion-footer class="modal-labjegyzet">
      <ion-toolbar>
        <div class="modal-gombsor">
          <span class="modal-sugo" *ngIf="!sorok.length">Válassz fájlt a mentéshez.</span>
          <ion-button color="primary" (click)="mentes()" [disabled]="mentesFut || !sorok.length">
            <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
            {{ mentesFut ? 'Mentés…' : (sorok.length ? 'Mentés (' + sorok.length + ' óra)' : 'Mentés') }}
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>

<!-- ── Megtekintés – ugyanígy modálban, hogy a lap egységes maradjon ──────── -->
<ion-modal [isOpen]="!!nezettPar" (didDismiss)="nezetBezar()">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>{{ parNev(nezettPar) }} tanmenete</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="nezetBezar()"><ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div class="tm-allapot" *ngIf="!nezettTetelek">
        <ion-spinner name="dots"></ion-spinner><span>Betöltés…</span>
      </div>
      <div class="tm-ures" *ngIf="nezettTetelek && !nezettTetelek.length">
        Ehhez a párhoz nincs egyetlen téma sem.
      </div>
      <div class="tm-tabla-burok" *ngIf="nezettTetelek?.length">
        <table class="tm-tabla">
          <thead><tr><th class="szam">Óra</th><th>Téma</th></tr></thead>
          <tbody>
            <tr *ngFor="let t of nezettTetelek"><td class="szam">{{ t.oraszam }}</td><td>{{ t.tema }}</td></tr>
          </tbody>
        </table>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
